module.exports = __webpack_public_path__ + "img/logo.edc63b7d.svg";